import { render, staticRenderFns } from "./EmailFooter.vue?vue&type=template&id=6da2d1a0"
import script from "./EmailFooter.vue?vue&type=script&lang=js"
export * from "./EmailFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports